import * as React from 'react';
import {connect} from 'react-redux';

import {Sidebar} from 'shells/sidebar/sidebar';

import {FormGoals} from '../../forms';
import {clearActiveItem} from '../../ui-actions';

type OwnProps = {
    isNew: boolean;
    entityId: string | null | undefined;
    parentId: string;
};

type DispatchProps = {
    closeForm: () => void;
};

type Props = OwnProps & DispatchProps;

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        closeForm: () => {
            dispatch(clearActiveItem());
        },
    };
}

class GoalsEditorComponent extends React.PureComponent<Props> {
    sidebarFormSubmitBtnRef: HTMLInputElement | null | undefined;

    render() {
        return (
            <Sidebar
                isOpen={true}
                preventBodyScroll={false}
                canClickOutsideToClose={false}
                canEscapeToClose={true}
                onClose={this.props.closeForm}
            >
                <FormGoals {...this.props} closeForm={this.props.closeForm} />
            </Sidebar>
        );
    }

    handleSidebarFormSave = () => {
        if (this.sidebarFormSubmitBtnRef) {
            this.sidebarFormSubmitBtnRef.click();
        }
    };
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);
export const GoalsEditor = connector(GoalsEditorComponent);
